import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { CardBody, CardText, CardTitle, GenericArticleCard, ImageContainer, VariableDeclarations } from './Base.style'

export const CoverArticleCard = styled.div`
	${VariableDeclarations};
	${GenericArticleCard};
	width: 100%;
	height: 345px;
	flex-direction: row;

	${ImageContainer} {
		border-radius: 8px 0 0 8px;
		width: var(--wide-image-width);
	}

	${CardBody} {
		height: 100%;
		width: calc(100% - var(--wide-image-width));
	}

	${CardText} {
		display: -webkit-box;
	}

	@media screen and (${PAGE_BREAKPOINTS.DESKTOP_MEDIUM}) {
		--wide-image-width: 62%;
	}

	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		--card-body-padding: 16px;
		--wide-image-width: 100%;
		min-height: 1vh;
		flex-direction: column;
		height: unset;

		${CardBody} {
			width: 100%;
		}

		${ImageContainer} {
			border-radius: 8px 8px 0 0;
			min-height: 200px;
		}

		${CardTitle} {
			font-size: 20px;
		}
	}
`

export const StandardArticleCard = styled.div`
	${VariableDeclarations};
	${GenericArticleCard};
	--card-body-min-height: 55%;
	width: 100%;
	max-width: 420px;
	height: 360px;
`

export const ResponsiveArticleCard = styled.div`
	${VariableDeclarations};
	${GenericArticleCard};
	--card-body-min-height: inherit;
	min-width: 290px;
	width: 100%;
	min-height: 300px;
	height: 100%;
`

export const SmallCard = styled.div`
	${VariableDeclarations};
	${GenericArticleCard};

	--card-body-padding: 14px;
	--wide-image-width: 100%;
	--card-body-min-height: 188px;

	height: 320px;
	width: 100%;
	max-width: 310px;

	${CardTitle} {
		font-size: 18px;
	}

	${CardText} {
		display: none;
	}

	${CardBody} {
		min-height: 180px;
	}
`
